import type {DefaultOptions} from '../../../types';
import type {HtmlValueEditorOptions} from './types';
import type {TextValueEditorLocalizations} from '../text/types';


/**
 * @ngdoc constant
 * @name HTML_VALUE_EDITOR_DEFAULT_OPTIONS
 * @module portaro.value-editors.html-editor
 *
 * @description
 * For description see {@link HtmlValueEditorOptions}
 *
 * Default value:
 *
 * ```javascript
 * {
 *      sanitizeInput: true,
 *     editorOptions: {
 *         actions: [
 *             'h1', 'h2', 'h3', 'h4', 'p', 'blockquote', 'b', 'i', 'u', 'strike', 'removeFormat', 'sup', 'sub',
 *             'left', 'center', 'right', 'justify', 'ul', 'ol', 'a', 'image', 'undo', 'redo', 'viewHtml'
 *         ]
 *     }
 *  }
 * ```
 */


export const HTML_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<HtmlValueEditorOptions> = {
    sanitizeInput: true,
    editorOptions: {
        actions: [
            'h1', 'h2', 'h3', 'h4', 'p', 'blockquote', 'b', 'i', 'u', 'strike', 'removeFormat', 'sup', 'sub',
            'left', 'center', 'right', 'justify', 'ul', 'ol', 'a', 'image', 'undo', 'redo', 'viewHtml'
        ]
    }
};

/**
 * @ngdoc constant
 * @name HTML_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.html
 *
 * @description
 * ```
 * {
 *      description: ''
 * }
 * ```
 */
export const HTML_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<TextValueEditorLocalizations>({
    description: ''
});